module.exports = __webpack_public_path__ + "static/media/Other-icon_On.81897bce.png";